export * from './model';
export * from './defaults';
export * from './actions';
export * from './utils';

export const OptionsDto = Object.freeze({
  DownloadMeters: 1,
  DownloadOthers: 0,
  DownloadUF44: 2,
  DownloadAll: 3
});
